export default "__VITE_ASSET__GbG18o2n__"